import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import type { UpdatePassportClientData } from '@/types/clientDetailsApiTypes';
import { useMutation } from '@tanstack/react-query';

export const useUpdateClientPassportData = () => {
  const { doFetch: updateClientPassportData } = useFetch<UpdatePassportClientData, void>();

  return useMutation<void, ErrorResponse<unknown>, { passportId: string, data: UpdatePassportClientData }>({
    mutationFn: ({ passportId, data }: { passportId: string, data: UpdatePassportClientData }) => updateClientPassportData(`/api/documents/passport/${passportId}`, { method: 'PUT', body: data }),
  });
};